<template>
    <div>
        <h3 v-if="title">{{title}}</h3>
        <div class="row">
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold" :for="'firstName' + _uid">{{$t('person.firstName') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="person.firstName"
                       :name="'firstName' + _uid"
                       :id="'firstName' + _uid">
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold" :for="'surName' + _uid">{{ $t('person.middleName') }}</label>
                <input type="text" class="form-control" v-model="person.middleName" :id="'surName' + _uid" readonly>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold" :for="'lastName' + _uid">{{ $t('person.lastName') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="person.lastName"
                       :name="'lastName' + _uid"
                       :id="'lastName' + _uid">
            </div>
            <div class="form-group col-md-12 col-lg-8 col-xl-8">
                <label class="font-weight-bold">{{ $t('person.identification') }}</label>
                <person-identification-details
                    :identification="person.personIdentification"></person-identification-details>
            </div>
            <div class="form-group col-md-12 col-lg-4 col-xl-4">
                <label class="font-weight-bold">{{ $t('person.gender') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="person.genderType"
                       :name="'denderType' + _uid"
                       :id="'denderType' + _uid">
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold" :for="'idCardNumber' + _uid">{{ $t('person.idCardNumber') }}</label>
                <input type="text"
                       readonly
                       class="form-control"
                       v-model="person.idCardNumber"
                       :name="'idCardNumber' + _uid"
                       :id="'idCardNumber' + _uid"/>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold" :for="'idCardDateOfIssue' + _uid">{{ $t('person.idCardDateOfIssue')
                    }}</label>
                <date-only-picker v-model="person.idCardDateOfIssue"
                                  read
                                  :enableTimePicker="false"
                                  :required="false"
                                  :readonly="true"
                                  :showTime="false"
                                  :id="'idCardDateOfIssue' + _uid"
                                  :name="'idCardDateOfIssue' + _uid">
                </date-only-picker>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold" :for="'idCardIssuedBy' + _uid">{{ $t('person.idCardIssuedBy') }}</label>
                <input type="text"
                       class="form-control"
                       v-model="person.idCardIssuedBy"
                       :name="'idCardIssuedBy' + _uid"
                       :id="'idCardIssuedBy' + _uid"
                       readonly/>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold" :for="'email' + _uid">{{ $t('email') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="person.email"
                       :name="'email' + _uid"
                       :id="'email' + _uid">
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold" :for="'phone' + _uid">{{ $t('person.phone') }}</label>
                <input type="text" class="form-control" v-model="person.phone" :id="'phone' + _uid" readonly>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold" :for="'mobilePhone' + _uid">{{ $t('person.mobilePhone') }}</label>
                <input type="text" class="form-control" v-model="person.mobilePhone" :id="'mobilePhone' + _uid"
                       readonly>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showPositionStatistic">
                <label class="font-weight-bold" :for="'PositionStatistic' + _uid">{{ $t('person.positionStatistic')
                    }}</label>
                <input type="text" class="form-control" v-model="person.positionStatisticDetails" readonly>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showPosition">
                <label class="font-weight-bold" :for="'position' + _uid">{{ $t('person.position') }}</label>
                <input type="text" class="form-control" v-model="isBgCulture? person.position : person.positionEn"
                       :id="'position' + _uid" readonly>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showPosition">
                <label class="font-weight-bold" :for="'positionStr' + _uid">{{ $t('person.position') }}</label>
                <input type="text"
                       class="form-control"
                       v-model="person.positionStr"
                       :name="'positionStr' + _uid"
                       :id="'positionStr' + _uid"
                       readonly/>
            </div>
            <div class="form-group col-md-12" v-if="showDescription">
                <label class="font-weight-bold" :for="'description' + _uid">{{ $t('person.description') }}</label>
                <textarea rows="3" class="form-control" v-model="person.description" :id="'description' + _uid"
                          readonly></textarea>
            </div>

            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showExtended">
                <label class="font-weight-bold" :for="'Salutation' + _uid">{{ $t('person.salutation') }}</label>
                <input type="text" class="form-control" v-model="person.salutationDetails" readonly>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showExtended">
                <label class="font-weight-bold" :for="'TitleDegree' + _uid">{{ $t('person.titleDegree') }}</label>
                <input type="text" class="form-control" v-model="person.titleDegreeDetails" readonly>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showExtended">
                <label class="font-weight-bold" :for="'EducationDegree' + _uid">{{ $t('person.educationDegree')
                    }}</label>
                <input type="text" class="form-control" v-model="person.educationDegreeDetails" readonly>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-6" v-if="showInstitution">
                <label class="font-weight-bold" :for="'institution' + _uid">{{$t("person.institution")}}</label>
                <div class="form-control" readonly>
                    <span>{{person.institutionDetails}}</span>
                    <span v-if="person.institutionLocationDetails"> / {{person.institutionLocationDetails}}</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {PersonDetails} from '../../models/models';
    import PersonIdentificationDetails from '../person/PersonIdentificationDetails';
    import DateOnlyPicker from '../datepicker/DateOnlyPicker';
    import {Culture} from '../../models/enums';

    export default {
        props: {
            person: PersonDetails,
            showDescription: {
                type: Boolean,
                default: false
            },
            showPosition: {
                type: Boolean,
                default: true
            },
            showDescription: {
                type: Boolean,
                default: false
            },
            showExtended: {
                type: Boolean,
                default: false
            },
            showPositionStatistic:{
                type: Boolean,
                default: true
            },
            showInstitution:{
                type: Boolean,
                default: true
            },
            title: String
        },
        components: {
            PersonIdentificationDetails,
            DateOnlyPicker
        },
        data() {
            return {}
        },
        computed: {
            isBgCulture() {
                return this.$store.getters.currentCulture === Culture.BG;
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    div[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
